import { NestedObjectKeys } from '@ringo/types'
import En from './locales/en.json'
import De from './locales/de.json'

export type WebI18NTranslationKeys = NestedObjectKeys<typeof En> & NestedObjectKeys<typeof De>
export type LanguageKey = 'de' | 'en' | 'es' | 'it' | 'fr' | 'nl' | 'pl' | 'ru' | 'tr' | 'cz' | 'ro' | 'hu' | 'hr'

async function getLangDynamically(lang: LanguageKey) {
    try {
        return (await import(`./locales/${lang}.json`)).default
    } catch (_) {
        return {}
    }
}

export { En, De, getLangDynamically }
